( () => {
  var e = {
      6131: e => {
          e.exports.isMobile = function() {
              return window.matchMedia("(max-width: 767px)").matches
          }
          ,
          e.exports.isMobileTablet = function() {
              return window.matchMedia("(max-width: 1023px)").matches
          }
          ,
          e.exports.isTablet = function() {
              return window.matchMedia("(min-width: 768px)").matches
          }
          ,
          e.exports.isDesktop = function() {
              return window.matchMedia("(min-width: 1024px)").matches
          }
          ,
          e.exports.isDesktopXl = function() {
              return window.matchMedia("(min-width: 1440px)").matches
          }
      }
  }
    , s = {};
  function i(t) {
      var a = s[t];
      if (void 0 !== a)
          return a.exports;
      var o = s[t] = {
          exports: {}
      };
      return e[t](o, o.exports, i),
      o.exports
  }
  ( () => {
      "use strict";
      var e = i(6131);
      $((function() {
          var s = 0
            , i = 0
            , t = !1
            , a = $(".js-hero-banner-carousel")
            , o = $(".js-hero-products-carousel")
            , n = 0
            , r = 5e3
            , d = e.isMobile() ? "speed-mobile" : "speed-desktop"
            , l = new MutationObserver((function(e) {
              e.forEach((function(e) {
                  $(e.addedNodes).each((function() {
                      $(this).is("video") && (s++,
                      $(this).on("loadedmetadata", (function() {
                          i++,
                          "desktop" === $(this).closest(".js-freecaster-player").attr("data-device-type") ? $(this).closest(".js-hero-banner-carousel-slide").attr("data-speed-desktop", 1e3 * this.duration) : $(this).closest(".js-hero-banner-carousel-slide").attr("data-speed-mobile", 1e3 * this.duration),
                          i === s && (n = a.find(".slick-current .js-hero-banner-carousel-slide").data(d) || r,
                          a.slick("slickSetOption", {
                              autoplay: !0,
                              autoplaySpeed: n
                          }),
                          a.slick("slickPlay"))
                      }
                      )))
                  }
                  ))
              }
              ))
          }
          ));
          $(window).on("load", (function() {
              var e, s, i, n;
              s = o,
              i = (e = a).data("carousel-autoplay"),
              (n = e.find(".hero-banner.video").length) && e.addClass("video-content"),
              i && n && (t = !0,
              i = !1),
              e.on("init", (function() {
                  e.find(".slick-active").addClass("initial-animation"),
                  setTimeout((function() {
                      e.find(".slick-active").removeClass("initial-animation"),
                      e.removeClass("initial-animation"),
                      e.addClass("custom-animation")
                  }
                  ), 1e3)
              }
              )).slick({
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  dots: !0,
                  arrows: !0,
                  speed: 1e3,
                  pauseOnFocus: !1,
                  pauseOnHover: !1,
                  focusOnSelect: !0,
                  adaptiveHeight: !0,
                  autoplay: i,
                  autoplaySpeed: r,
                  asNavFor: ".js-hero-products-carousel",
                  responsive: [{
                      breakpoint: 1023,
                      settings: {
                          arrows: !1
                      }
                  }]
              }).on("beforeChange", (function(s, i, a, o) {
                  var n = a + 1
                    , l = parseInt(e.slick("slickGetOption", "autoplaySpeed")) || 0
                    , c = e.slick("getSlick").$slides.eq(o).find(".js-hero-banner-carousel-slide").data(d) || r;
                  t && l !== c && e.slick("slickSetOption", {
                      autoplaySpeed: c
                  }),
                  e.find(".slick-slide").removeClass("slick-target moving-out"),
                  (a > o && (0 !== o || 1 === a) || 0 === a && o === i.slideCount - 1) && (n = a - 1),
                  a !== o && (e.find('[data-slick-index="'.concat(a, '"]')).addClass("moving-out"),
                  e.find('[data-slick-index="'.concat(n, '"]')).addClass("slick-target"))
              }
              )).on("afterChange", (function() {
                  e.find(".slick-slide").removeClass("moving-out")
              }
              )),
              s.slick({
                  slidesToShow: 1,
                  adaptiveHeight: !0,
                  slidesToScroll: 1,
                  arrows: !1,
                  dots: !1,
                  cssEase: "ease",
                  speed: 1e3,
                  fade: !0,
                  asNavFor: ".js-hero-banner-carousel"
              }),
              t && l.observe(a[0], {
                  childList: !0,
                  subtree: !0
              })
          }
          ))
      }
      ))
  }
  )()
}
)();


